import { render, staticRenderFns } from "./BlDoAlarmPop.vue?vue&type=template&id=1fe4677a"
import script from "./BlDoAlarmPop.vue?vue&type=script&lang=js"
export * from "./BlDoAlarmPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fe4677a')) {
      api.createRecord('1fe4677a', component.options)
    } else {
      api.reload('1fe4677a', component.options)
    }
    module.hot.accept("./BlDoAlarmPop.vue?vue&type=template&id=1fe4677a", function () {
      api.rerender('1fe4677a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BlDoAlarmPop.vue"
export default component.exports